'use strict';

var curry = require('./curry.js');
require('./chunk-ba04ad2f.js');
var _append = require('./_append.js');

/**
 * Appends a value to a list.
 *
 * @function
 * @param a The value to append.
 * @param {Array|String} bs The list.
 * @returns {Array|String} A list that contains the value `a` appended to the
 * list of `bs`.
 * @example
 *
 * import { append } from 'fkit'
 * append(3, [1, 2]) // [1, 2, 3]
 * append('o', 'fo') // 'foo'
 */

var append = curry(_append);

module.exports = append;
